import { ApiOrgProduct } from '@kaiizen/kai-pro-api';
import { useAllProductSupplierOrgs } from '@kaiizen/kai-pro-api-react-state';

import { getOrgProductIsAvailable } from '@/Client/Lib';

import { FocusedLineItemStrip, FocusedLineItemStripButton, FocusedLineItemStripMessage } from './FocusedLineItemStrip';
import { FocusedLineItemTab } from './FocusedLineItemTab';
import { FOCUSED_LINE_ITEM_TAB_ERROR } from './focusedTaskCardStyles';

/** Whether the line item's product is out of stock: it has one, and its supplier can't provide it. */
export const useOrgProductIsOutOfStock = (orgProduct: ApiOrgProduct | undefined): boolean => {
  const { productSupplierOrgs } = useAllProductSupplierOrgs();
  return !!orgProduct && !getOrgProductIsAvailable(orgProduct, productSupplierOrgs?.homeDepot?.id);
};

/** The strip under an out-of-stock row: its tag, why it's blocked, and Find replacement when a product can be picked. */
export const FocusedLineItemOutOfStockStrip = ({ onFindReplacement }: { onFindReplacement?: () => void }) => (
  <FocusedLineItemStrip
    testId='focused-line-item-out-of-stock-strip'
    isError
    actions={onFindReplacement && <FocusedLineItemStripButton onClick={onFindReplacement}>Find replacement</FocusedLineItemStripButton>}
  >
    <FocusedLineItemTab
      variantStyle={FOCUSED_LINE_ITEM_TAB_ERROR}
      testId='focused-line-item-out-of-stock-tab'
      explanationTitle='Out of Stock'
      explanation="This product is out of stock at its supplier, so it can't be ordered as is."
    >
      {'Out of stock'}
    </FocusedLineItemTab>
    <FocusedLineItemStripMessage>{'Unavailable from this supplier.'}</FocusedLineItemStripMessage>
  </FocusedLineItemStrip>
);
